module.exports = __webpack_public_path__ + "img/spins_1920.96a0ad44.png";